// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__faxpr","footer":"ModalCreateQualiphyProcedure_footer__exTcr","additionData":"ModalCreateQualiphyProcedure_additionData__2X4uR"};